module.exports = __webpack_public_path__ + "static/media/certMSSCIF.0897f2e0.pdf";